import { render, staticRenderFns } from "./Mess.vue?vue&type=template&id=2d582bc8&scoped=true&"
import script from "./Mess.vue?vue&type=script&lang=js&"
export * from "./Mess.vue?vue&type=script&lang=js&"
import style0 from "./Mess.vue?vue&type=style&index=0&id=2d582bc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d582bc8",
  null
  
)

export default component.exports